var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex align-items-center user-info"
  }, [_c('div', {
    staticClass: "fio-circle-column"
  }, [_c('div', {
    staticClass: "fio-circle"
  }, [_c('r-icon', {
    attrs: {
      "icon": "avatar",
      "size": "16",
      "fill": "amelie"
    }
  })], 1)]), !this.hideFio ? _c('div', {
    staticClass: "fio-column"
  }, [_c('div', {
    staticClass: "roquefort fio-ellipsis"
  }, [_vm._v(" " + _vm._s(_vm.fio) + " ")])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }